import Backbone from 'backbone'
import template from './no-object.hbs'
import metadata from 'scoreboard/components/metadata'
import _ from 'lodash'
import EmptyState from './empty-state'
import i18n from 'scoreboard/components/i18n'

var NoObjectView = Backbone.View.extend({

	className: 'display-layout no-object empty-state',

	/**
	 * @param {String} options.section
	 *
	 * @param {String} [options.noTypeText=i18n('common.missing.domainObject.1')]
	 * 	A value to display when there are no objects.
	 * 	e.g. i18n.get('bookmarks.missing.1')
	 *
	 * @param {Boolean} [opt.escapeNoTypeText=true] if true, opt.noTypeText will
	 * be escaped and sent through i18n. If false, noTypeText will be rendered
	 * as HTML
	 */
	initialize: function(options) {
		this.options = _.extend({ escapeNoTypeText: true }, options)
	},

	render: function() {
		let sectionMetadata = metadata[this.options.section]
		Backbone.trigger('pageTitle', i18n.get(sectionMetadata.pluralCode))
		let noTypeCode = sectionMetadata.noTypeCode
		// #57835 don't try to mutable the metadata object, just add the
		// noTypeLabel to the context
		let noTypeLabel
		if (noTypeCode) {
			let noTypeMsg = i18n.get(noTypeCode)
			noTypeLabel = noTypeMsg.toLowerCase()
		}

		var context = _.defaults({
			section: this.options.section,
			sectionSubstitution: this.options.sectionSubstitution,
			noTypeText: this.options.noTypeText,
			escapeNoTypeText: this.options.escapeNoTypeText,
			noTypeLabel
		}, sectionMetadata)

		// EmptyState also has a .display-layout.empty-state wrapper, so we
		// can just unwrap it and place it here since we already have those classes
		var emptyState = new EmptyState({
			body: template(context),
			noHeader: this.options.noHeader
		}).render().$el.children()

		this.$el.append(emptyState)
		return this
	}
})

export default NoObjectView

NoObjectView.__filename__ = 'components/no-object.js'
